import { gql } from "@apollo/client";

export const UNLOCK_VEHICLE = gql`
  mutation releaseBooking($id: String!) {
    releaseBooking(bookingScheduleId: $id)
  }
`;
